import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["escape", "portal", "size", "fixed", "outside", "print", "hideCloseButton"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Modal } from '../../internal/components/Modal';
import { ModalWindowView, modalWindowViewDefaultProps } from './ModalWindowView';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера модального окна в виде окошка с крестиком внутри
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=34047-22478&t=dWJSsCGr4smKrzpW-4)
 */
export function ModalWindow(_ref) {
  var _ref$escape = _ref.escape,
    escape = _ref$escape === void 0 ? true : _ref$escape,
    _ref$portal = _ref.portal,
    portal = _ref$portal === void 0 ? true : _ref$portal,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? modalWindowViewDefaultProps.size : _ref$size,
    _ref$fixed = _ref.fixed,
    fixed = _ref$fixed === void 0 ? modalWindowViewDefaultProps.fixed : _ref$fixed,
    _ref$outside = _ref.outside,
    outside = _ref$outside === void 0 ? modalWindowViewDefaultProps.outside : _ref$outside,
    _ref$print = _ref.print,
    print = _ref$print === void 0 ? modalWindowViewDefaultProps.print : _ref$print,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? modalWindowViewDefaultProps.hideCloseButton : _ref$hideCloseButton,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({
    escape: escape,
    portal: portal
  }, props), {}, {
    children: /*#__PURE__*/_jsx(ModalWindowView, _objectSpread(_objectSpread({
      fixed: fixed,
      size: size,
      outside: outside,
      print: print,
      hideCloseButton: hideCloseButton
    }, props), {}, {
      children: props.children
    }))
  }));
}